<div class="container">
    <app-breadcrumb [crumbs]="crumbs"></app-breadcrumb>

    <table class="table table-hover table-last-col table-add-row">
        <thead>
            <tr>
                <th>Naam</th>
                <th>Azure naam</th>
                <th>Afas debtor id</th>
            </tr>
        </thead>
        <tbody>
            @for (company of companies(); track company.id) {
                <tr class="curpoint" routerLink="/{{Routenames.companies}}/{{company.id}}">
                    <td>{{company.name}}</td>
                    <td>{{company.azure_desc}}</td>
                    <td>{{company.afas_debtor_id}}</td>
                </tr>
            } @empty {
                <tr>
                    <td class="text-center" colspan="99">
                        @if (companies() === null) {
                            Aan het laden...
                        } @else {
                            Geen bedrijven gevonden
                        }
                    </td>
                </tr>
            }
            @if (!showCreate) {
                <tr>
                    <td colspan="99">
                        <button class="w-100 btn btn-secondary" routerLink="/{{Routenames.companies}}/new">
                            Bedrijf toevoegen <i class="fas fa-plus"></i>
                        </button>
                    </td>
                </tr>
            }
        </tbody>
    </table>
</div>
